import { z } from "zod";

import { BooleanOperator, Operator } from "../operators.ts";
import type { IResolvableBooleanValue } from "../values.ts";
import { ResolvableBooleanValue } from "../values.ts";
import type { IBinaryCondition } from "./common.ts";
import { binaryCondition } from "./common.ts";

// Zod value schema for boolean conditions
const BooleanValue = z.union([z.boolean(), ResolvableBooleanValue]);

// Zod schemas with type discriminator
export const BooleanBinaryCondition = binaryCondition(z.literal("boolean"), BooleanOperator, BooleanValue);
export type BooleanBinaryCondition = z.infer<typeof BooleanBinaryCondition>;

export const BooleanCondition = z.discriminatedUnion("operator", [
  binaryCondition(z.literal("boolean"), z.literal(Operator.EQ), BooleanValue),
  binaryCondition(z.literal("boolean"), z.literal(Operator.NE), BooleanValue),
]);
export type BooleanCondition = z.infer<typeof BooleanCondition>;

// Interfaces for complex types (verified to match schemas)
export interface IBooleanBinaryCondition extends IBinaryCondition<
  typeof Operator.EQ | typeof Operator.NE,
  boolean | IResolvableBooleanValue
> {
  type: "boolean";
}

// Type compatibility assertion - compile-time check that inferred type matches interface
type _AssertBinaryCompatible = BooleanBinaryCondition extends IBooleanBinaryCondition ? true : never;
const _binaryCheck: _AssertBinaryCompatible = true;
void _binaryCheck;
